import { gql } from '@apollo/client';
import type { MyPermissionsQuery } from '../generated';

export const MY_PERMISSIONS_QUERY = gql`
  query MyPermissions {
    myPermissions
  }
`;

export type MyPermissionsResponse = MyPermissionsQuery;
